<section>

    <nav>

        <div class="left-menu">
            <a routerLink="/contact-us" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">CONTACT
                US</a>
            <a routerLink="/faq" routerLinkActive="active" [routerLinkActiveOptions]="{exact:true}">FAQ</a>
        </div>

        <div class="right-menu">

            <a (click)="changeAccount()" [textContent]="this.accountName()"></a>

            <a kendoButton (click)="openAccountContacts()">
                Account Contacts
            </a>

            <div class="login-status">

                <div class="login-link">

                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M13.7767 0.424805C6.16505 0.424805 0 6.58986 0 14.2015C0 21.8131 6.16505 27.9781 13.7767 27.9781C21.3883 27.9781 27.5533 21.8131 27.5533 14.2015C27.5533 6.58986 21.3883 0.424805 13.7767 0.424805ZM13.7767 4.5578C16.0567 4.5578 17.9097 6.41076 17.9097 8.6908C17.9097 10.9777 16.0567 12.8238 13.7767 12.8238C11.4966 12.8238 9.64366 10.9777 9.64366 8.6908C9.64366 6.41076 11.4966 4.5578 13.7767 4.5578ZM13.7767 24.1207C10.3256 24.1207 7.29474 22.3572 5.51066 19.6846C5.5451 16.9499 11.0282 15.4414 13.7767 15.4414C16.5251 15.4414 22.0013 16.9499 22.0427 19.6846C20.2586 22.3572 17.2277 24.1207 13.7767 24.1207Z"
                            fill="white" />
                    </svg>

                    @if (isAuthenticated()) {
                    @if (userName() == "") {
                    <kendo-loader type="pulsing" size="medium" themeColor="light">
                    </kendo-loader>
                    } @else {
                    <a (click)="logout()" [textContent]="statusText()"></a>
                    }
                    } @else {
                    <!-- Should not be here -->
                    }
                </div>
            </div>

        </div>

    </nav>

</section>

<app-change-account [(show)]="showChangeAccount">
</app-change-account>

<app-account-contact [(show)]="showAccountContacts"></app-account-contact>



